// eslint-disable-next-line import/no-anonymous-default-export
export default {
  toolsTitle: 'HitPaw en ligne ultime',
  freeTimesLimitTitle: "L'essai du compte gratuit s'achève aujourd'hui.",
  fileSizeLimitTitle:
    'La taille du fichier pour le compte gratuit ne peut excéder 20 Mo.',
  freeImgCutoutTimesLimitTitle:
    "La période d'essai d'aujourd'hui pour la suppression de l'arrière-plan est terminée, veuillez passer à la version Pro pour accéder à toutes les fonctions Premium.",
  total: 'Tous',
  enterCode: 'Entrez le code',
  signUpToPurchaseBtn: 'Inscrivez-vous et acheter',
  goPurchseBtn: "Aller à l'achat",
  saveTips: "Économisez jusqu'à {{num}} %",
  discount: 'Remises',
  priceWeek: '9,99€',
  priceMonth: '7,49€',
  priceYear: '3,75€',
  billedMonth: '29,99 € Facturé mensuellement',
  billedYear: '179,99 € Facturé annuellement',
  week: 'Semaine',
  weekly: 'Hebdomadaire',
  monthly: 'Mensuel',
  yearly: 'Chaque année',
  AlreadySubscribe: 'Déjà inscrit?',
  vipTips1: 'Aucune limite de taille de fichier',
  vipTips2: 'Nombre illimité de fichiers à traiter',
  vipTips3: "Modifier l'arrière-plan des images sans limite",
  vipTips4: 'Accès à tous les outils gratuits et aux fonctionnalités premium',
  purchaseTips: 'Renouvellement automatique et annulation à tout moment',
  tips: 'Note:',
  promoCodeInvalidTips: "Votre code promo n'est pas valide",
  //2022.09.28 xxy
  freeImgBgChangerTimesLimitTitle:
    'Today’s trial oppotunity for changing background has been run out, please upgrade to Pro to access all premium features',
  vipBgChangerTips: 'Change image backgrounds without limits',
};
